import React, { Component } from "react";
import Pagination from '@mui/material/Pagination';
import Select from "react-select";
import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../components/Navbar";
import { tokens, select_style, toFixed, total, fieldSorter, GET, format_date, getStorage, loading, alert } from "../../components/CustomComponent.js";

const view_r = getStorage("role_detail")?.find(item => item.name === "capital-payment-info")?.role[0] === 1;

export default class CapitalPaymentInfo extends Component {
  state = {
    page: 1,
    filter_address_number: null,
    filter_type: null,
    type: "",
    data: null,
    data_address: [],
    data_paylist: [],
  };

  async componentDidMount() {
    loading(false); // ปิดการโหลดทันทีเมื่อเข้ามาหน้าแรก
    if (view_r) await this.GetAll();
  }

  GetAll = async () => {
    loading(true);
    const [res1, res2] = await Promise.all([
      GET(tokens, `v1/TH/customer-manage/filter-search/page/0/${getStorage("project_id")}`, { data_search: "", transfer_date: "", status_transfer: "" }),
      GET(tokens, "v1/TH/document-manage/pay-list/filter-search/page/0", null)
    ]);

    const data_address = res1?.status ? res1.data.data.map(item => ({ value: item.address_number, label: `อาคาร ${item.building} ห้อง ${item.address_number}` })) : [];
    const data_paylist = res2?.status ? res2.data.data : [];
    const filter_type = data_paylist.length ? { value: data_paylist[0].code, label: `${data_paylist[0].code} ${data_paylist[0].title}` } : null;

    this.setState({ data_address, data_paylist, filter_type }, this.GetDataAll);
  };

  GetDataAll = async () => {
    loading(true);
    const { page, filter_address_number, filter_type } = this.state;
    
    let result = await GET(tokens, `v1/TH/record-receipt/bill-funds/filter-search/page/${page}/${getStorage("project_id")}`, { 
      address_number: filter_address_number?.value || "", 
      type: filter_type?.value || "" 
    });

    if (result?.status) {
      this.setState({ data: result.data, type: filter_type?.label || "" });
    }
    loading(false);
  };

  Print = async (iw_number) => {
    loading(true);
    try {
      const array_cost = ["add_debt", "cable_cost", "common_expenses", "equipment_maintenance_fee", "fire_cost", "late_payment", "meter_connect_cost", "other_income", "reduce_debt", "waste_cost", "water_bill"];
      let result = await GET(tokens, `v1/TH/record-receipt/history/by-iw-number/${getStorage("project_id")}`, { iw_number });
      
      if (result?.status) {
        let data = result.data.data;
        const baseHeader = {
          project_name: getStorage("project_name"),
          project_address: `เลขที่ ${getStorage("project_address")}\nเบอร์โทรติดต่อ ${getStorage("phone_number")} เลขที่ผู้เสียภาษี ${getStorage("tax_number")}`,
          cutomer_name: data.full_name,
          cutomer_address: data.address || data.address_number,
          number: data.iw_number,
          date: format_date(data.record_date, "dd mmmm yyyy"),
          payment: data.payment_type === 1 ? "เงินสด" : "โอนเงินเข้าบัญชีนิติฯ",
          payment_date: `${format_date(data.transfer_date || data.record_date, "dd/mm/yyyy")} เวลา ${(data.transfer_time || data.record_time)?.slice(0, 5)}`
        };

        if (data?.record_other_list?.length > 0) {
          const otherInfo = data.record_other_list[0];
          localStorage.setItem("DATA_", JSON.stringify({ ...baseHeader, title: otherInfo.title, description: otherInfo.description, cost: otherInfo.cost, total: otherInfo.cost, change_satang: 0 }));
          window.open("/doc/receipt-other", "_blank");
        } else {
          data.transaction_payments.sort(fieldSorter(["water_current_month"]));
          const fst = data.transaction_payments[0];
          
          const getP = (type) => fst[`s_${type}`] ? fst[type == "late_payment" ? "total_cost_late" : type] : 0;
          const getT = (arr) => arr.reduce((acc, item) => acc + array_cost.reduce((sum, type) => sum + total([item].filter(e => e[`s_${type}`]), type === 'late_payment' ? 'total_cost_late' : type), 0), 0);
          
          const water_list_price = getT(data.transaction_payments.slice(1));
          const total_calc = water_list_price + getT([fst]) + data.add_on_add_debt + data.change_satang - data.add_on_reduce_debt;
  
          const lastMonth = new Date(data.last_date);
          lastMonth.setMonth(lastMonth.getMonth() - 1);
  
          localStorage.setItem("DATA_", JSON.stringify({
            ...baseHeader,
            water_current_month: data.last_date,
            water_last_month: data.brefore_last_date !== data.last_date ? data.brefore_last_date : format_date(lastMonth, "yyyy-mm-dd", "en"),
            last_gauge_number: data.last_gauge_number, current_gauge_number: data.current_gauge_number, unit_used: data.unit_used,
            water_bill: getP("water_bill"), equipment_maintenance_fee: getP("equipment_maintenance_fee"),
            waste_cost: getP("waste_cost"), common_expenses: getP("common_expenses"),
            water_list: data.transaction_payments || [], water_list_price: parseFloat(water_list_price.toFixed(2)),
            meter_connect_cost: getP("meter_connect_cost") + total(data.transaction_payments.slice(1).filter((e) => e.s_meter_connect_cost), "meter_connect_cost"), total_cost_late: getP("late_payment"),
            fire_cost: getP("fire_cost"), cable_cost: getP("cable_cost"), other_income: getP("other_income"),
            add_debt: getP("add_debt"), add_on_add_debt: data.add_on_add_debt,
            reduce_debt: getP("reduce_debt"), add_on_reduce_debt: data.add_on_reduce_debt,
            total: parseFloat(total_calc.toFixed(2)), change_satang: data.change_satang,
          }));
          window.open("/doc/receipt", "_blank");
        }
      } else {
        alert("warning", "แจ้งเตือน", "ไม่มีใบแจ้งหนี้");
      }
    } catch (e) {
      alert("warning", "แจ้งเตือน", "เกิดข้อผิดพลาดในการโหลดข้อมูล");
    } finally {
      loading(false);
    }
  };

  render() {
    const { data, data_address, data_paylist, filter_address_number, filter_type, page } = this.state;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ข้อมูลจัดเก็บค่าใช้จ่าย" page3="ข้อมูลการรับชำระเงินทุน" />

        <div className="body">
          <div className="p-3">
          <div className="card border-0 p-3">
            <h4 className="mb-3"><b>ข้อมูลการรับชำระเงินทุน</b></h4>
            
            {view_r && (
              <div className="d-flex align-items-center mb-3">
                <Select
                  className="bg-contain border-0 select-search wpx-200 mx-1"
                  styles={select_style} options={data_address}
                  onChange={(e) => this.setState({ filter_address_number: e })}
                  value={filter_address_number}
                />
                <Select
                  className="bg-contain border-0 select-search wpx-200 mx-1"
                  styles={select_style} options={data_paylist.map(e => ({ value: e.code, label: `${e.code} ${e.title}` }))}
                  onChange={(e) => this.setState({ filter_type: e })}
                  value={filter_type}
                />
                <button className="btn btn-primary px-3 mx-1" onClick={() => this.setState({ page: 1 }, this.GetDataAll)}>ค้นหา</button>
                <button className="btn btn-outline-primary px-3 mx-1" onClick={() => this.setState({ 
                  filter_address_number: null, 
                  filter_type: data_paylist.length ? { value: data_paylist[0].code, label: `${data_paylist[0].code} ${data_paylist[0].title}` } : null, 
                  page: 1 
                }, this.GetDataAll)}>รีเซ็ท</button>
              </div>
            )}

            <div className="table-responsive">
              <table className="table table-borderless table-striped text-nowrap">
                <thead>
                  <tr className="bg-dark-blue text-white">
                    <th>ห้องเลขที่</th><th>ชื่อ-นามสกุล</th><th>ยอดชำระ</th>
                    <th>เลขที่ใบเสร็จรับเงิน</th><th>วันที่ใบเสร็จรับเงิน</th><th>รายละเอียด</th>
                    <th className="text-center">พิมพ์</th>
                  </tr>
                </thead>
                <tbody>
                  {!data?.data?.length ? (
                    <tr><td colSpan={7} className="text-center">ไม่มีข้อมูล</td></tr>
                  ) : (
                    data.data.map((item, index) => (
                      <tr key={index}>
                        <td className="text-nowrap">{item.address_number || "-"}</td>
                        <td className="text-nowrap">{item.full_name || "-"}</td>
                        <td>{toFixed(item.cost || 0)}</td>
                        <td>{item.iw_number || "-"}</td>
                        <td>{item.record_date ? format_date(item.record_date, "dd/mm/yyyy") : "-"}</td>
                        <td>{item.description || "-"}</td>
                        <td className="text-center">
                          <label className="wpx-24 hpx-24 bg-primary-light rounded-1 d-inline-flex align-items-center justify-content-center m-0 pointer" onClick={() => this.Print(item.iw_number)}>
                            <i className="icon text-primary">&#xf02f;</i>
                          </label>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {data?.data?.length > 0 && (
              <div className="d-flex justify-content-between align-items-center mt-2 w-100">
                <label>แสดง {data.end_index} รายการ จาก {data.count} รายการ</label>
                <Pagination count={data.page_number} page={page} color="primary" showFirstButton showLastButton onChange={(e, value) => this.setState({ page: value }, this.GetDataAll)} />
              </div>
            )}
          </div>
        </div>
      </div>
      </div>
    );
  }
}